export default function isValidUSZip(zip) {
  return /^[A-Za-z]\d[A-Za-z] ?\d[A-Za-z]\d$/.test(zip)
}
